const styles = {
  LT: {
    fontFamily: "SF Pro",
    fontSize: 43,
    letterSpacing: 0.374,
    // lineHeight: 41,
    fontWeight: "400",
  },
  H1: {
    fontFamily: "SF Pro",
    fontSize: 28,
    letterSpacing: 0.364,
    // lineHeight: 34,
  },
  H2: {
    fontFamily: "SF Pro",
    fontSize: 22,
    letterSpacing: 0.35,
    // lineHeight: 28,
  },
  H3: {
    fontFamily: "SF Pro",
    fontSize: 20,
    letterSpacing: 0.35,
    // lineHeight: 25,
  },
  H4: {
    fontFamily: "SF Pro",
    fontSize: 17,
    fontWeight: "600",
    letterSpacing: -0.408,
    // lineHeight: 22,
  },
  P1: {
    fontFamily: "SF Pro",
    fontSize: 17,
    fontWeight: "400",
    letterSpacing: -0.408,
    // lineHeight: 22,
  },
  P2: {
    fontFamily: "SF Pro",
    fontSize: 16,
    fontWeight: "400",
    letterSpacing: -0.32,
    // lineHeight: 21,
  },
  P3: {
    fontFamily: "SF Pro",
    fontSize: 15,
    fontWeight: "400",
    letterSpacing: -0.24,
    // lineHeight: 20,
  },
  C1: {
    fontFamily: "SF Pro",
    fontSize: 13,
    fontWeight: "400",
    letterSpacing: -0.078,
    // lineHeight: 18,
  },
  C2: {
    fontFamily: "SF Pro",
    fontSize: 12,
    fontWeight: "400",
    letterSpacing: -0.078,
    // lineHeight: 16,
  },
  C3: {
    fontFamily: "SF Pro",
    fontSize: 11,
    fontWeight: "400",
    letterSpacing: 0.066,
    // lineHeight: 13,
  },
  base: { color: "white" },
  true: {
    fontFamily: "SF Pro Text Medium",
    // fontWeight: 600,
    // letterSpacing: -0.966,
  },
};

// ? font-family: "SF Pro Text Medium";
// font-size: 16px;
// line-height: 20px;

export default styles;
